
    import { mapState, mapMutations, mapActions } from 'vuex';
    import Filters from '@/components/Utils/Filters';

    export default {
        name: 'JobViewApplyCtaIncomplete',

        mixins: [Filters],

        props: {
            buttonSize: {
                type: String,
                default: 'lg',
            },
        },

        data() {
            return {
                spinner: {
                    resume_apply: false,
                },
            };
        },

        computed: {
            ...mapState({
                $_job: state => state.job.job,
                $_jobApplication: state => state.jobApplication,
                $_isApplyEnabled: state => state.job.is_apply_enabled,
            }),
        },

        methods: {
            ...mapMutations('jobApplication', {
                $_OPEN_CUSTOM_QUESTIONS: 'OPEN_CUSTOM_QUESTIONS',
            }),

            ...mapActions('jobApplication', {
                $_getJobQuestions: 'getJobQuestions',
            }),

            resumeApply() {
                this.spinner.resume_apply = true;
                this.$_getJobQuestions({ jobUuid: this.$_job.uuid, applicationUuId: this.$_jobApplication.apply_uuid }).then(() => {
                    if (this.$_jobApplication.questions.length) {
                        this.$_OPEN_CUSTOM_QUESTIONS();
                    }
                }).finally(() => {
                    this.spinner.resume_apply = false;
                });
            },
        },
    };
